import { sanitizeDangerousChildren } from "./sanitizeDangerousChildren";
export var spreadDangerousChildren = function spreadDangerousChildren(children) {
  return {
    children: typeof children !== 'string' ? children : null,
    dangerouslySetInnerHTML: typeof children === 'string' ? {
      __html: sanitizeDangerousChildren(children)
    } : undefined
  };
};